
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { useAuthContext } from '@/context-state/AuthContext.jsx'
import { useAccountSpaces } from '@/hooks/useAccountSpaces.jsx'
import { useEffect } from 'react'

export default function SpaceDefault() {

    const { spaceId, accountId } = useParams()
    const { spaces, logout } = useAuthContext()
    const { accountSpaces } = useAccountSpaces()
    const navigate = useNavigate()


    useEffect(() => {
        // If the user has no spaces at all (across every account), send them to auth
        if (!spaces.length) {
            console.log('no spaces')
            logout()
            return
        }

        // The chosen account has no spaces - nothing to land on, render nothing
        // rather than redirecting (which would loop). Real accounts always have
        // at least one space, so this is a defensive guard.
        if (!accountSpaces.length) {
            return
        }

        // Check if we're at the /account/:accountId/space route without a spaceId
        if (window.location.pathname === `/account/${accountId}/space`) {
            navigate(`/account/${accountId}/space/${accountSpaces[0]._id}`)
            return
        }

        // Check if current spaceId belongs to the chosen account
        const currentSpace = accountSpaces.find(space => space._id === spaceId)

        // If the space isn't one of this account's spaces, redirect to its first space
        if (!currentSpace) {
            navigate(`/account/${accountId}/space/${accountSpaces[0]._id}`)
        }
    }, [spaceId, spaces, accountSpaces])

    if (!spaces.length) {
        return null
    }

    return <Outlet />

}